// extracted by mini-css-extract-plugin
export default {"Results":"searchResults_Results__PT216","SearchResults":"searchResults_SearchResults__5eEJo"};